import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
  } from 'recharts';
  
  export const TruckPieChart = ({rawData, isLoading}: {rawData?: Record<string, { total: number, percentage: number , vehicleCount:number, driverCount:number }>, isLoading: boolean}) => {
    if(isLoading || !rawData) return <></>;
    const chartData = Object.entries(rawData)
      .map(([name, value]) => {
        let label = `${name}: ${value.total} companies`;

        if (value.vehicleCount && value.vehicleCount > 0) {
          label += ` (Trucks: ${value.vehicleCount})`;
        } else if (value.driverCount && value.driverCount > 0) {
          label += ` (Drivers: ${value.driverCount})`;
        }

        return {
          name: label,
          value: value.total,
        };
      })
      .filter((item) => item.value > 0);

    const COLORS = [
        "#0088FE", "#00C49F", "#FFBB28", "#FF8042",
        "#A28EFF", "#FF6384", "#36A2EB", "#FFCE56",
        "#4BC0C0", "#9966FF"
      ];
    return (
      <ResponsiveContainer width="100%" height={400} >
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={140}
            label
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value: number, label: string) => [`${label}`]}
            itemStyle={{padding: '4px 10px'}}
          />
          <Legend
            layout="vertical"
            verticalAlign="middle"
            align="right"
          />
        </PieChart>
      </ResponsiveContainer>
    );
  };
  